module.exports = __webpack_public_path__ + "static/media/im_folder.4568d8e0.svg";